import { Link } from 'react-router-dom';
import { LifeBuoy, CreditCard } from 'lucide-react';
import styles from './Footer.module.css';

/**
 * Props del componente Footer
 * @param copyrightText - Texto de copyright
 * @param copyrightLink - URL del enlace de copyright (opcional)
 * @param showMyPlan - Si se muestra el enlace de "Mi Plan"
 * @param showSupport - Si se muestra el enlace de soporte
 * @param isCollapsed - Si el sidebar está colapsado (para ajustar el left del footer)
 */
export interface FooterProps {
  copyrightText?: string;
  copyrightLink?: string;
  showMyPlan?: boolean;
  showSupport?: boolean;
  isCollapsed?: boolean;
}

export const Footer = ({
  copyrightText = `© ${new Date().getFullYear()} Zafiro ERP`,
  copyrightLink,
  showMyPlan = true,
  showSupport = true,
  isCollapsed = false,
}: FooterProps) => {
  return (
    <div className={`${styles.footer} ${isCollapsed ? styles.footerCollapsed : ''}`}>
      <div className={styles.containerFluid}>
        <span className={styles.copyright}>
          {copyrightLink ? (
            <Link to={copyrightLink} className={styles.copyrightLink}>
              {copyrightText}
            </Link>
          ) : (
            copyrightText
          )}
        </span>

        {(showMyPlan || showSupport) && (
          <ul className={styles.nav}>
            {showMyPlan && (
              <li className={styles.navItem}>
                <a
                  href="#"
                  className={styles.navbarNavLink}
                  onClick={(e) => {
                    e.preventDefault();
                    // TODO: Implementar navegación a "Mi Plan"
                    console.log('Navegar a Mi Plan');
                  }}
                >
                  <div className={styles.navLinkContent}>
                    <CreditCard size={16} />
                    <span className={styles.navLinkText}>Mi Plan</span>
                  </div>
                </a>
              </li>
            )}

            {showSupport && (
              <li className={styles.navItem}>
                <a
                  href="#"
                  className={styles.navbarNavLink}
                  onClick={(e) => {
                    e.preventDefault();
                    // TODO: Implementar navegación a soporte
                    console.log('Navegar a Soporte');
                  }}
                >
                  <div className={styles.navLinkContent}>
                    <LifeBuoy size={16} />
                    <span className={styles.navLinkText}>Soporte</span>
                  </div>
                </a>
              </li>
            )}
          </ul>
        )}
      </div>
    </div>
  );
};

